import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const KIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="KI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FFC84A"
          d="m8.074 4.048.272-.474.088.539.354-.419-.011.546.424-.349-.11.536.48-.269-.204.508.52-.179-.292.463.544-.084-.37.403.55.014-.437.332.54.111-.49.25.51.203-.527.159.466.292-.547.062.405.37-.55-.036.333.436-.534-.133.248.487-.501-.224.156.523-.453-.31.06.543-.39-.385-.038.545-.315-.449-.135.53-.23-.496-.228.496-.136-.53-.314.449-.04-.545-.39.385.06-.543-.453.31.158-.523-.502.224.249-.487-.535.133.332-.436-.548.035.405-.369L5.4 6.63l.465-.292-.527-.159.51-.204-.489-.249.539-.111-.437-.332.55-.014-.37-.403.543.084-.29-.463.519.179-.203-.508.48.269-.11-.536.424.349-.012-.546.354.419.087-.539.274.474.182-.515.184.515Z"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M-.396 6.96.91 6.43a.781.781 0 0 1 .594.002l1.816.755c.205.086.437.08.638-.016l1.464-.703c.21-.101.454-.103.665-.005l1.534.708a.781.781 0 0 0 .652.002l1.57-.716a.781.781 0 0 1 .65.002l1.55.715a.781.781 0 0 0 .642.006l1.693-.746a.781.781 0 0 1 .58-.02l1.517.546v5.007H-.44l.045-5.007Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={18}
          height={6}
          x={-1}
          y={6}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M-.396 6.96.91 6.43a.781.781 0 0 1 .594.002l1.816.755c.205.086.437.08.638-.016l1.464-.703c.21-.101.454-.103.665-.005l1.534.708a.781.781 0 0 0 .652.002l1.57-.716a.781.781 0 0 1 .65.002l1.55.715a.781.781 0 0 0 .642.006l1.693-.746a.781.781 0 0 1 .58-.02l1.517.546v5.007H-.44l.045-5.007Z"
            clipRule="evenodd"
          />
        </Mask>
        <G mask="url(#c)">
          <Path
            stroke="#015989"
            d="m-.396 8.123 1.307-.53a.781.781 0 0 1 .594.002l1.816.755c.205.086.437.08.638-.017l1.464-.702c.21-.101.454-.103.665-.005l1.534.708a.781.781 0 0 0 .652.002l1.57-.716a.781.781 0 0 1 .65.002l1.55.715a.78.78 0 0 0 .642.006l1.693-.746a.781.781 0 0 1 .58-.02l1.517.546M-.396 9.787l1.307-.53a.781.781 0 0 1 .594.002l1.816.756c.205.085.437.08.638-.017l1.464-.703c.21-.1.454-.102.665-.005L7.622 10a.781.781 0 0 0 .652.001l1.57-.715a.781.781 0 0 1 .65.001l1.55.716a.781.781 0 0 0 .642.005l1.693-.745a.781.781 0 0 1 .58-.02l1.517.545"
          />
          <Path
            fill="#015989"
            fillRule="evenodd"
            d="m-.396 11.114.546-.222a2.781 2.781 0 0 1 2.114.01l1.057.44c.205.085.437.078.638-.018l.615-.295a2.781 2.781 0 0 1 2.37-.018l.678.314a.781.781 0 0 0 .652.002l.734-.335a2.781 2.781 0 0 1 2.32.005l.716.33a.78.78 0 0 0 .642.007l.962-.424a2.78 2.78 0 0 1 2.062-.072l.766.276v1.657H-.304l-.092-1.657Z"
            clipRule="evenodd"
          />
        </G>
        <Path
          fill="#FFC84A"
          fillRule="evenodd"
          d="M4.89 1.71h.93c.235 0 .763-.36 1.069-.24.306.12.82.505.82.505s.85-.67 1.357-.67 1.421-.075 1.421-.075-.214.557-.818.651c-.603.094-1.325.556-1.325.556h.98c.15 0 .345.226.345.226s-.402.273-.603.273h-.423s-.427.366-.955.289c-.527-.078-.95-.562-.95-.562s-.462-.067-.462-.146c0 0-.284-.146-.37 0-.086.146.37-.195.37-.195s.183-.172.322-.172c.14 0 .605.287.605.287l.111-.115-.576-.441c-1.177.123-1.848-.172-1.848-.172Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
